import { useContext } from 'react'

import { ThemeContext } from '@/app/providers/theme-context'

export function useTheme() {
  return useContext(ThemeContext)
}
